module.exports = __webpack_public_path__ + "img/folder.45c21d45.svg";